import "rxjs/Rx";

import { HttpClient, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";

@Injectable()
export class PersonRequestService {
  public mdmId: any;
  constructor(private http: HttpClient) { }

  getPerson(personId: string): Observable<Object> {
    return this.http.get("/api/PEople/" + personId).map(res => {
      const data = (<any>res).json();
      return data;
    });
  }

  uploadFile(file: File, description: string, documentTypeId: string) {
    const formData: FormData = new FormData();
    formData.append("file", file, file.name);
    formData.append("description", description);
    formData.append("documentTypeId", documentTypeId);

    const req = new HttpRequest("POST", "/api/AwsS3/uploadDocument", formData, {
      responseType: "json"
    });
    return this.http.request(req);
  }

  downloadFile(fileName: string, personId: string, requestId: string) {
    return window.open(
      "/api/InternalPersonDocument/downloadRequestDetailDocument?file=" +
      fileName +
      "&personId=" +
      personId +
      "&requestId=" +
      requestId
    );
  }

  deleteFile(fileName: string) {
    const req = new HttpRequest(
      "GET",
      "/api/AwsS3/deleteDocument?file=" + fileName
    );
    return this.http.request(req);
  }

  getPersonById(personId) {
    return this.http.get(`/api/InternalPerson/getPersonById`, {
      params: { type: personId },
      responseType: "json"
    });
  }
  getPersonNameById(personId) {
    return this.http.get(`/api/InternalPersonName/getPersonNameById`, {
      params: { type: personId },
      responseType: "json"
    });
  }
  getPersonAddressById(personId) {
    return this.http.get(`/api/InternalPersonAddress/getPersonAddressById`, {
      params: { type: personId },
      responseType: "json"
    });
  }
  getPersonDocumentById(personId) {
    return this.http.get(`/api/InternalPersonDocument/getPersonDocumentById`, {
      params: { type: personId },
      responseType: "json"
    });
  }
  getDisabilities() {
    return this.http.get("/api/getDisabilities", { responseType: "json" });
  }
  getDisabilitiesCategoryName(DISABILITY_CATEGORY_ID) {
    return this.http.get("api/DisabilityCategory/getDisabilitiesCatName", {
      params: { type: DISABILITY_CATEGORY_ID },
      responseType: "json",
      observe: "response"
    });
  }
  getDisabilitiesName(DISABILITY_ID) {
    return this.http.get("api/Disability/getDisabilitiesName", {
      params: { type: DISABILITY_ID },
      responseType: "json",
      observe: "response"
    });
  }
  getPersonDisabilityById(personId) {
    return this.http.get(
      `/api/InternalPersonDisability/getPersonDisabilityById`,
      { params: { type: personId }, responseType: "json" }
    );
  }

  getPlanById(planId) {
    return this.http.get(`/api/InternalPlan/plans/${planId}`, {
      responseType: "json"
    });
  }
  getPersonPlanById(personId) {
    return this.http.get(`/api/InternalPersonPlan/getPersonPlanById`, {
      params: { PERSON_ID: personId },
      responseType: "json"
    });
  }
  getPersonTestById(personId) {
    return this.http.get(`/api/InternalPersonTest/getPersonTestById`, {
      params: { type: personId },
      responseType: "json"
    });
  }

  getPersonTestDetails(personId, testDateId) {
    return this.http.get(`/api/InternalPersonTest/getPersonTestDetails`, {
      params: { personId: personId, testDateId: testDateId },
      responseType: "json"
    });
  }
  getPersonRequestForDisplay(requestId) {
    return this.http.get(`/api/internalRequest/getPersonRequestForDisplay`, {
      params: { type: requestId },
      responseType: "json"
    });
  }
  // getTest() {
  //     return this.http.get(`/api/internalTest/getTest`);
  // }
  getTestNameById(testId) {
    return this.http.get(`/api/internalTest/getTestNameById`, {
      params: { type: testId },
      responseType: "json",
      observe: "response"
    });
  }

  getTestNameByTestId(testId) {
    return this.http.get(`/api/internalTest/getTestNameById`, {
      params: { type: testId },
      responseType: "json"
    });
  }

  getTestDateName(testDateId) {
    return this.http.get(
      `/api/internalTestAdministrations/getTestDateNameById`,
      { params: { type: testDateId }, responseType: "json" }
    );
  }

  getTestDateNameById(testDateId) {
    return this.http.get(
      `/api/internalTestAdministrations/getTestDateNameById`,
      {
        params: { type: testDateId },
        responseType: "json",
        observe: "response"
      }
    );
  }
  // getDates(testId) {
  //     return this.http.get(`/api/internalTest/getDates`, { params: { "id": testId }, responseType: 'json', observe: 'response' });
  // }
  getPersonTestAdmin(personId) {
    return this.http.get(
      `/api/internalTestAdministrations/getPersonTestAdmin`,
      { params: { type: personId }, responseType: "json" }
    );
  }

  getReqAccomsById(requestId) {
    return this.http.get(`/api/InternalReqAccoms/getReqAccoms`, {
      params: { type: requestId },
      responseType: "json"
    });
  }

  getAccomsName(accomsId) {
    return this.http.get(`/api/internalaccommodation/getAccomsName`, {
      params: { type: accomsId },
      responseType: "json",
      observe: "response"
    });
  }

  getAccomsCategoryName(accomsId) {
    return this.http.get(
      `/api/internalaccommodationcategory/getAccomsCatName`,
      { params: { type: accomsId }, responseType: "json", observe: "response" }
    );
  }

  getDocumentTypeById(documentId) {
    return this.http.get(`/api/internaldocumenttype/documentTypes/${documentId}`, {
      responseType: "json",
      observe: "response"
    });
  }

  getRequestCommentsById(requestId) {
    return this.http.get(`/api/internalrequestcomment/getRequestCommentById`, {
      params: { type: requestId },
      responseType: "json",
      observe: "response"
    });
  }

  getRequestStatusCodeById(codeId) {
    return this.http.get(`/api/RequestStatusCode/getRequestStatusCodeById`, {
      params: { type: codeId },
      responseType: "json"
    });
  }
  getReviewDetailId(personId: string) {
    return this.http.get(`/api/internalRequest/getReviewDetailId`, {
      params: { PERSON_ID: personId },
      responseType: "json"
    });
  }
  createRequestComment(data) {
    return this.http.post(
      `/api/internalrequestcomment/createRequestComment`,
      data,
      { observe: "response" }
    );
  }

  updateRequestStatus(data) {
    return this.http.put(`/api/internalRequest/updateRequestStatus`, data, {
      observe: "response"
    });
  }

  updateReviewDetailStatus(data) {
    return this.http.put(
      `/api/internalReviewDetail/updateReviewDetailStatus`,
      data,
      {
        observe: "response"
      }
    );
  }

  getLogDetails(personId: string, requestId: string) {
    return this.http.get(`/api/internalLogger/logDetails`, {
      params: { PERSON_ID: personId, REQUEST_ID: requestId },
      responseType: "json"
    });
  }

  getAccomDetails(reqID) {
    return this.http.get(`/api/internalaccommodation/getAccommsInReviewPage`, {
      params: { requestId: reqID },
      responseType: "json",
      observe: "response"
    });
  }
  updateStatus(data) {
    return this.http.put(
      `/api/internalconsultantreviewsubmit/updateRequestedAccommodation`,
      data,
      { observe: "response" }
    );
  }
  getSpecAuth(requestId: string) {
    return this.http.get(`/api/internalconsultantreviewsubmit/getSpecAuth`, {
      params: { REQUEST_ID: requestId },
      responseType: "json"
    });
  }

  postAccomsType(data) {
    return this.http.post(`/api/AccommsType/postAccomsType`, data, {
      observe: "response"
    });
  }

  postTestType(data) {
    return this.http.post(`/api/TestType/postTestType`, data, {
      observe: "response"
    });
  }

  /**
   * @description Makes a post to the rabbitMq after a decision has been made on an examinee request
   * Called only if the test date has not passed and the person test type is Special and the selected
   * test date is a National test date.
   * @requires Payload to drop on the queue for pickup
   */
  postRabbitMq(data) {
    return this.http.post(`/api/Rabbitmq/postRabbitMq`, data, {
      observe: "response"
    });
  }

  getSourceFlag() {
    return this.http.get(`/api/Rabbitmq/getSourceFlag`, {
      responseType: "json",
      observe: "response"
    });
  }

  createReviewDetailId(data) {
    return this.http.post(
      `/api/internalReviewDetail/createInternalReviewDetailId`,
      data,
      { observe: "response" }
    );
  }
  updateReviewDetailId(data) {
    return this.http.put(
      `/api/internalReviewDetail/updateInternalReviewDetailId`,
      data,
      { observe: "response" }
    );
  }
  putPersonTest(data) {
    return this.http.put(`/api/InternalPersonTest/putPersonTest`, data, {
      observe: "response"
    });
  }

  getTestCoordinator(data) {
    return this.http.get(`/api/InternalSalesforce/getTestCoordinators`, {
      params: {
        mdmId: data
      },
      observe: "response"
    });
  }

  setOrg(data) {
    this.mdmId = data;
  }

  getOrg() {
    return this.mdmId || "";
  }

  saveUserDetails(data) {
    return this.http.put(
      `/api/InternalPersonTest/updatePersonUserDetails`,
      data,
      {
        observe: "response"
      }
    );
  }

  getOrgMdmId(id) {
    return this.http.get("/api/InternalPersonTest/getOrgMdmID", {
      params: {
        orgId: id
      },
      observe: "response"
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/services/person-request-service.ts